export default __webpack_public_path__ + "static/media/flower-top-big.e520a110.png";